<template>
    <div>
        <h5>Manage Departments</h5>
        <div>
            <Toolbar v-if="authStore.hasPermission(UserPermission.WRITE_DEPARTMENT)" class="mb-4 card">
                <template v-slot:start>
                    <div class="my-2">
                        <Button label="Add Department" icon="pi pi-plus" class="p-button-success mr-2" @click="dialogForm = true" />
                    </div>
                </template>
            </Toolbar>

            <!-- create department form -->
            <department-form v-if="dialogForm" @hide-dialog="dialogForm = false" />

            <!-- department table -->
            <department-table class="card" />
        </div>
    </div>
</template>

<script setup>
import DepartmentForm from '../modules/DepartmentForm.vue';
import DepartmentTable from '../modules/DepartmentTable.vue';
import { ref } from 'vue';
import { authStore } from '../../../../../store/global-stores';
import { UserPermission } from '../../../../../modules/permission/enum';
const dialogForm = ref(false);
</script>
